import { simpleSet } from '@r/reducers/utils';
import { AllActions, _ISimpleSet } from '@r/storeUtils';

const s = simpleSet as _ISimpleSet<
  redux._IConstants['SET_WALLS'],
  redux._IStore['projectFor3d']['walls'],
  AllActions
>;
export const walls = s( 'SET_WALLS', { label: '', value: '', baseMap: '' } );
